const siteUrl = 'https://www.astonmartininventory.com/'

module.exports = {
  /* Your site config here */
  siteMetadata: {
    title: 'AstonMartin',
    siteUrl:'https://www.astonmartininventory.com/',
    site_id: '66313d5b17c7a728065f1983',
    api_base_url: 'https://api.dealermasters.com:4500',
    lead_url: 'https://leads.dealermasters.com/leads',
    master_sites: [],
    autocheck_url: 'https://n1u6ywp1bf.execute-api.us-east-2.amazonaws.com/default/AutoCheckFastLink',
      quickgenAPI: 'https://dev.mxsapi.com',
      imageBaseURL: 'https://images.mxssolutions.com'
  },
  plugins: [
    'gatsby-plugin-react-helmet',
    {
      resolve: "gatsby-plugin-force-trailing-slashes"
    },
    {
      resolve: 'gatsby-plugin-advanced-sitemap',
      options: {
      },
    },
    {
      resolve: "gatsby-plugin-emotion"
    },
    {
      resolve: "gatsby-transformer-json"
    },
    {
      resolve: "gatsby-plugin-sass",
      options: {
        cssLoaderOptions: {
          camelCase: false,
        },
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /\.inline\.svg$/
        }
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `src`,
        path: `${__dirname}/src/`
      }
    },
    {
      resolve: 'gatsby-plugin-s3',
      options: {
        bucketName: 'mxs-89d5bd93-90c1-457e-98dd-4ee088b6aba3-prodsite'
      }
    },
    `gatsby-transformer-json`,
    {
      resolve: require.resolve('./plugins/gatsby-source-dynamodb-query'),
      options: {
        typeName: 'altInventory',
        region: 'us-east-2',
        tableName: 'AdjustedInventory',
        dealerId: ['219326-sold','219339-sold']//126024
      }
    },
    { 
      resolve: require.resolve('./plugins/gatsby-source-dynamodb-query'),
      options: {
        typeName: 'inventory',
        region: 'us-east-2',
        tableName: 'AdjustedInventory',
        dealerId: ['2193269','2193399']//126024
      }
    },
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        icon: 'static/favicon.png'
      }
    },{
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: 'https://www.astonmartininventory.com/',
        sitemap: 'https://www.astonmartininventory.com/sitemap-pages.xml',
        policy: [{ userAgent: '*', allow: '/' }]
      }
    }
  ]
}